import { css } from 'lit';

export const accordionOnDarkStyles = css`
  --_accordion__color--enabled: var(--sbkAccordionFgColorOnDarkEnabled);
  --_accordion__color--hover: var(--sbkAccordionFgColorOnDarkHover);
  --_accordion__color--active: var(--sbkAccordionFgColorOnDarkActive);
  --_accordion__focus: var(--sbkAccordionOnDarkFocus);
  --_accordion__borderRadius--focus: var(--sbkAccordionBorderRadiusFocus);
`;
